import * as React from 'react'
import TextContainer from '../layout/TextContainer';


type Props = {
  className?: string
}

const TerminalIntroSection: React.FC<Props> = ({ className = '' }) => {

  return (
    <div className={' ' + className}>
      <TextContainer>

        <h2 className="text-xl font-bold mb-2 text-gray-800">What is this?</h2>
        <p>
          Terminal score debugger is an attempt to reverse-engineer 
          the Lightning Labs <a className="text-viking-800 hover:text-viking-700" 
          target="_blank" href="https://terminal.lightning.engineering/">Terminal Web Score</a>.
          It gives insights on how a node is ranked and how to improve a nodes ranking.
          </p>
          <p>The debugger focuses on the heuristics that Terminal applies to judge a node.</p>
      </TextContainer>
    </div>
  );
}

export default TerminalIntroSection;

